/* Global theme utilities: no-js flag + Markets country/language auto-submit. */
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-country-select], [data-language-select]')) {
    event.target.closest('form')?.submit();
  }
});
